import axios from 'axios'

import { apiUrl } from '@/api/base.js'

export default {
    get_self_score (args) {
        return axios.get(`${apiUrl}v2/skill_self_score/`, { params: args })
    },
    get_categories (args) {
        return axios.post(`${apiUrl}v2/get_categories/`, { params: args })
    },
    get_skill_from_category_for_submit (args) {
        return axios.get(`${apiUrl}v2/get_skill_from_category_for_submit/`, { params: args })
    },
    get_skill_category_info (args) {
        return axios.get(`${apiUrl}v2/get_skill_category_info/`, { params: args })
    },
    get_skill_category_info_for_target (args) {
        return axios.get(`${apiUrl}v2/get_skill_category_info_for_target/`, { params: args })
    },
    get_skill_from_category (args) {
        return axios.get(`${apiUrl}v2/get_skill_from_category/`, { params: args })
    },
    get_skill_and_plan_from_category (args) {
        return axios.get(`${apiUrl}v2/get_skill_and_plan_from_category/`, { params: args })
    },
    post_self_score(args){
        return axios.post(`${apiUrl}v2/post_self_score/`, { params: args })
    },
    skill(args){
        return axios.post(`${apiUrl}v2/skill/`, { params: args })
    },
    check_user_skill(args){
        return axios.post(`${apiUrl}v2/check_user_skill/`, { params: args })
    },
    set_skill_state(args){
        return axios.post(`${apiUrl}v2/set_skill_state/`, { params: args })
    },
    set_skill_plan(args){
        return axios.post(`${apiUrl}v2/set_skill_plan/`, { params: args })
    },
    post_skill_submit_file(args){
        return axios.post(`${apiUrl}v2/post_skill_submit_file/`, {params: args}, { 'content-type': 'multipart/form-data' })
    },
    get_category_skill_info(args) {
        return axios.get(`${apiUrl}v2/get_category_skill_info/`, { params: args })
    },
    get_category_skill_info_for_plan(args) {
        return axios.get(`${apiUrl}v2/get_category_skill_info_for_plan/`, { params: args })
    },
    get_my_skill_targets() {
        return axios.get(`${apiUrl}v2/get_my_skill_targets/`)
    },
}